import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


export const getJournalsReq = (action) => {
    const { societyId, ...params } = action?.data || {};
    const url = apiEndpoints.GET_JOURNALS_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params });
}

export const getJournalDetailsReq = (action) => {
    const { societyId, journalId } = action?.data || {};
    const url = apiEndpoints.GET_JOURNAL_DETAILS_API
        .replace(':societyId', societyId)
        .replace(':journalId', journalId);
    return axiosInstance.get(url);
}

export const createJournalReq = (action) => {
    const payload = { ...action?.data } || {};
    delete payload.onSuccess;
    return axiosInstance.post(apiEndpoints.CREATE_JOURNAL_API, payload);
}

export const updateJournalReq = (action) => {
    const { societyId, journalId, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.UPDATE_JOURNAL_API
        .replace(':societyId', societyId)
        .replace(':journalId', journalId);
    return axiosInstance.put(url, payload);
}

export const deleteJournalReq = (action) => {
    const { societyId, journalId } = action?.data || {};
    const url = apiEndpoints.DELETE_JOURNAL_API
        .replace(':societyId', societyId)
        .replace(':journalId', journalId);
    return axiosInstance.delete(url);
}

export const getAccountHeadsReq = (action) => {
    const societyId = action?.data?.societyId || '';
    const url = apiEndpoints.GET_ACCOUNT_HEADS_API.replace(':societyId', societyId);
    return axiosInstance.get(url);
}

export const getJournalAuditLogsReq = (action) => {
    const { societyId, journalId, ...params } = action?.data || {};
    const url = apiEndpoints.GET_JOURNAL_AUDIT_LOGS_API
        .replace(':societyId', societyId)
        .replace(':journalId', journalId);
    return axiosInstance.get(url, { params });
}

export const bulkValidateJournalsReq = (action) => {
    const { societyId, file } = action?.data || {};
    const url = apiEndpoints.BULK_VALIDATE_JOURNALS_API.replace(':societyId', societyId);
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

export const bulkUploadJournalsReq = (action) => {
    const { societyId, file } = action?.data || {};
    const url = apiEndpoints.BULK_UPLOAD_JOURNALS_API.replace(':societyId', societyId);
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

export const getChartOfAccountsDropdownReq = (action) => {
    const { societyId, ...params } = action?.data || {};
    const url = apiEndpoints.GET_CHART_OF_ACCOUNTS_DROPDOWN_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params });
}
